import { render } from "./QuickpayPaymentTicket.vue?vue&type=template&id=3a6ca7b0&scoped=true"
import script from "./QuickpayPaymentTicket.vue?vue&type=script&lang=js"
export * from "./QuickpayPaymentTicket.vue?vue&type=script&lang=js"

import "./QuickpayPaymentTicket.vue?vue&type=style&index=0&id=3a6ca7b0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6ca7b0"]])

export default __exports__